const mbConstantReducer = (
    state = {
      data: {}
    },
    action: {
      type: "SET_MB_CONSTANT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_MB_CONSTANT":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default mbConstantReducer;